import { Component } from '@angular/core';

@Component({
  selector: 'fury-error-crawling-web-form',
  templateUrl: './error-crawling-web-form.component.html',
  styleUrls: ['./error-crawling-web-form.component.scss']
})
export class ErrorCrawlingWebFormComponent {}
